module.exports = __webpack_public_path__ + "img/p2.c8ae3a20.png";